"use client";
import Image, { ImageProps } from "next/image";

interface Props extends ImageProps {
  /** Skip the progressive effect entirely (e.g. small/logo images). Renders a plain image. */
  disableEffect?: boolean;
}

/**
 * A thin wrapper around next/image. 
 * The previous custom progressive load effect has been removed to improve performance.
 */
const ProgressiveImage: React.FC<Props> = ({
  disableEffect,
  ...rest
}) => {
  return <Image {...rest} />;
};

export default ProgressiveImage;
